<template>
  <v-container fill-height fluid grid-list-xl v-if="$store.state.menu.Serials">
    <Loader :loading="loading" />
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="Список наклеек" text="DTE">
          <v-btn class="mr-2" color="primary" @click="getSerials(false)" text
            >Обновить</v-btn
          >
          <v-btn @click="openExport" color="danger" text>Экспорт excel</v-btn>

          <br />

          <div class="mt-2">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск..."
              class="sticky search"
              :loading="loadingSearch"
              single-line
              hide-details
              clearable="true"
            ></v-text-field>
          </div>

          <v-data-table :headers="headers" :items="PagesList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>

            <template slot="items" slot-scope="{ item }">
              <td>
                <img
                  v-if="
                    item.option &&
                    item.option.product &&
                    item.option.product.images &&
                    item.option.product.images.length
                  "
                  :src="item.option.product.images[0].image_medium"
                  height="60"
                  width="60"
                  style="object-fit: contain"
                  alt
                />

                <img
                  v-else
                  src="img/no-image.png"
                  height="60"
                  width="60"
                  style="object-fit: contain"
                />
              </td>

              <td
                :class="`text-xs-left ${
                  (item.option && item.option.reward === 0) ||
                  item.option === null
                    ? 'error--text'
                    : ''
                }`"
              >
                {{ item.code }}
              </td>

              <td class="text-xs-left">
                <span v-if="item.option && item.option.product">{{
                  item.option.serial_number
                }}</span>
                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.option && item.option.product">{{
                  item.option.product.vendor_code
                }}</span>
                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.option && item.option.product">{{
                  item.option.product.name
                }}</span>
                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.option && item.option.product"
                  >{{ item.option.reward | numberWithSpaces }} сум</span
                >
                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>

              <td class="text-xs-left">
                <span
                  class="text-success"
                  v-if="item.option && item.option.product"
                  >{{
                    item.option.conditional_price | numberWithSpaces
                  }}
                  сум</span
                >
                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.option && item.option">
                  <span
                    class="text-success"
                    v-if="
                      item.option.activations && item.option.activations.dealer
                    "
                  >
                    <small>
                      {{ item.option.activations.dealer.first_name }}
                      {{ item.option.activations.dealer.last_name }}
                    </small>
                    <Br />
                    {{ item.option.activations.dealer.phone_number }}
                  </span>
                  <span v-else>Не активирован</span>
                </span>

                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.option && item.option">
                  <span
                    class="text-success"
                    v-if="
                      item.option.activations_client &&
                      item.option.activations_client.client
                    "
                  >
                    <small>
                      {{ item.option.activations_client.client.first_name }}
                      {{ item.option.activations_client.client.last_name }}
                    </small>
                    <Br />
                    {{ item.option.activations_client.client.phone_number }}
                  </span>

                  <span v-else>Не активрован</span>
                </span>
                <span v-else>
                  <small>Товар не установлен</small>
                </span>
              </td>
            </template>
          </v-data-table>

          <div class="horizontal-scroll">
            <v-pagination
              total-visible="20"
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </div>

          <div v-if="$store.state.menu.Serials && $store.state.role[12]">
            <v-text-field
              :clearable="true"
              v-model="serialText"
              type="text"
              :label="`Введите через пробел серийные номера`"
            ></v-text-field>

            <v-btn @click="resetSerials" color="danger" text
              >Сбросить наклейки</v-btn
            >
          </div>
        </material-card>
      </v-flex>
    </v-layout>

    <v-dialog
      width="400"
      persistent
      transition="dialog-bottom-transition"
      v-model="export_data.length && !loading"
    >
      <v-card>
        <v-card-text>
          <div class="body-2">Выгрузите экспорт</div>
          <br />
          <br />
          <download-excel
            v-if="export_data.length && loading === false"
            :data="export_data"
            :fields="json_fields_all_products"
            :name="'export_' + exportFileName"
          >
            <v-btn color="warning" text style="width: 100%">Скачать</v-btn>
          </download-excel>

          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn
            color="primary"
            text
            style="width: 100%"
            @click="export_data = []"
            >Закрыть</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loader from "../components/helper/Loader";

import { mapMutations } from "vuex";
import Page from "../components/core/Pages/Page";

export default {
  data: () => ({
    serialText: "",

    //export
    exportFileName: "",

    json_fields_all_products: {
      "Серийный номер наклейки": "code",
      "Серийный номер товара": "serial_number",
      Артикул: "vendor_code",
      "Наименование товара": "product_name",
      Награда: "reward",
      "Цена ACC": "conditional_price",
      "Дилер ": "dealer_name",
      "Дилер номер телефона": "dealer_phone",
      Клиент: "client_name",
      "Клиент номер телефона": "client_phone",
    },
    export_data: [],
    //export

    Page_title: "",
    PageAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "",
        value: "dealer.title",
      },

      {
        sortable: false,
        text: "Серийный номер наклейки",
        value: "id",
      },

      // {
      //     sortable: false,
      //     text: 'Статус',
      //     value: 'dealer.title'
      // },

      {
        sortable: false,
        text: "С/н товара",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Артикул",
        value: "dealer.phone_number",
      },

      {
        sortable: false,
        text: "Наименование товара",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Награда",
        value: "dealer.phone_number",
      },

      {
        sortable: false,
        text: "Цена ACC",
        value: "dealer.phone_number",
      },

      {
        sortable: false,
        text: "Дилер активация",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Клиент активация",
        value: "dealer.phone_number",
      },
    ],
    PagesList: [],
    pageID: null,
  }),
  components: { Page, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getSerials();
      }
    },
    resetSerials() {
      if (this.serialText) {
        let cleanedStr = this.serialText.replace(/\s{2,}/g, " ");
        let serials = cleanedStr.split(" ");

        const options = {
          method: "POST",
          url: "https://customerservice.uz/api/exchange-1c/reset-activation",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW46bHR5YmMxOTkxIUA=",
          },
          data: { serials: serials },
        };
        axios
          .request(options)
          .then((response) => {
            this.$toast.success({
              title: "Сброс",
              message: "Серийники успешно добалвены в очередь на удаление",
            });
            this.serialText = null;
          })
          .catch(function (error) {
            alert("Ошибка сервера");
          });
      }
    },
    openExport() {
      this.exportFileName = "serials.xls";
      this.loading = true;

      setTimeout(() => {
        axios
          .get("admin/export/serials", {
            params: {
              search: this.search,
            },
          })
          .then(async (response) => {
            this.export_data = await response.data;
          })
          .catch((error) => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          });
      }, 100);
    },

    getSerials(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/codes/list", {
          params: {
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.PagesList = response.data.data;
          this.last_page = response.data.last_page;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },
    openPage(pageID) {
      this.pageID = pageID;
    },

    closePage(update) {
      if (update) {
        this.getSerials(false);
      }
      this.pageID = null;
    },

    addPage() {
      if (this.Page_title) {
        axios
          .post("admin/pages/set", {
            title: this.Page_title,
          })
          .then((response) => {
            if (response.data) {
              this.getSerials(true);
              this.openPage(response.data.id);
              this.Page_title = "";
            }
            this.$toast.success({
              title: "Успешно добавно",
              message: "Добавлена новая страница.",
            });
          })
          .catch((error) => {
            let data = error.response.data;
            if (data.errors) {
              let k = 0;
              Object.keys(data.errors).forEach((item) => {
                let err = data.errors[item];
                k++;
                for (let i = 0; i < err.length; i++) {
                  setTimeout(() => {
                    this.$toast.error({
                      title: "Ошибка",
                      message: err[i],
                    });
                  }, 100 * k);
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.PageAddModal = false;
          });
      } else {
        this.$toast.error({
          title: "Заголовок",
          message: "Введите заголовок",
        });
      }
    },
  },

  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getSerials(true);
      }, 1500);
    },
    page() {
      setTimeout(() => {
        this.getSerials();
      }, 300);
    },
  },
  mounted() {
    this.getSerials();
  },
};
</script>
